import { when } from "hooks/useWhen";
import { FLOODLIGHT_ARGS } from "consts/feature-config";
import { getSessionId } from "utils/sessionManager";
import { Helmet } from "react-helmet";

export default function FloodlightEvent({ tag }) {
  const floodlightFeatureFlag = when(FLOODLIGHT_ARGS);

  const sessionId = getSessionId();
  const region = "US";

  if (!floodlightFeatureFlag) return null;

  //tag parts for noscript fallback tracking pixel
  const tagParts = tag.split("/");
  const src = tagParts[0]?.replace("DC-", "") || "14832541";
  const type = tagParts[1] || "pageview";
  const cat = tagParts[2]?.split("+")[0] || "";

  return (
    <>
      <Helmet>
        <script>
          {`
            if (typeof gtag === 'function' && window.getCkyConsent && window.getCkyConsent().categories.analytics) {
              gtag('event', 'conversion', {
                'allow_custom_scripts': true,
                'session_id': '${sessionId}',
                'u15': '${region}',
                'send_to': '${tag}'
              });
            }
          `}
        </script>
      </Helmet>
      <noscript>
        <img
          src={`https://ad.doubleclick.net/ddm/activity/src=${src};type=${type};cat=${cat};u15=${region};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ord=${sessionId}?`}
          width="1"
          height="1"
          alt=""
        />
      </noscript>
    </>
  );
}
